"use strict";

exports.__esModule = true;
exports.Modal = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactUtils = require("@okee-uikit/react-utils");

var _reactHooks = require("@okee-uikit/react-hooks");

var _reactConfig = require("@okee-uikit/react-config");

var _icons = require("../../common/icons");

var _layer = require("../../context/layer");

var _Content = require("../util/Content");

var _dialog = require("../../units/dialog");

var _ModalFooter = require("./ModalFooter");

var _excluded = ["show", "children", "header", "footer", "divider", "type", "wrapperClassName", "wrapperStyle", "mask", "maskClosable", "maskClassName", "maskStyle", "bodyClassName", "bodyStyle", "className", "style", "closeable", "afterClose", "lazyInit", "hideToDestroy", "footerRef", "onClose", "onCancel", "onOk", "cancelButtonProps", "okButtonProps", "cancelText", "okText", "top", "width", "height", "size", "icon", "disableAnimation", "defaultShow", "domRef", "keyboard"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Modal = _react.default.forwardRef(function (props, ref) {
  var _useConfig = (0, _reactConfig.useConfig)(),
      lockScroll = _useConfig.lockScroll;

  var unsafeShow = props.show,
      children = props.children,
      header = props.header,
      footer = props.footer,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      _props$type = props.type,
      type = _props$type === void 0 ? 'normal' : _props$type,
      wrapperClassName = props.wrapperClassName,
      wrapperStyle = props.wrapperStyle,
      _props$mask = props.mask,
      mask = _props$mask === void 0 ? true : _props$mask,
      _props$maskClosable = props.maskClosable,
      maskClosable = _props$maskClosable === void 0 ? false : _props$maskClosable,
      maskClassName = props.maskClassName,
      maskStyle = props.maskStyle,
      bodyClassName = props.bodyClassName,
      bodyStyle = props.bodyStyle,
      className = props.className,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      _props$closeable = props.closeable,
      closeable = _props$closeable === void 0 ? true : _props$closeable,
      afterClose = props.afterClose,
      _props$lazyInit = props.lazyInit,
      lazyInit = _props$lazyInit === void 0 ? true : _props$lazyInit,
      hideToDestroy = props.hideToDestroy,
      footerRef = props.footerRef,
      onClose = props.onClose,
      onCancel = props.onCancel,
      onOk = props.onOk,
      _props$cancelButtonPr = props.cancelButtonProps,
      cancelButtonProps = _props$cancelButtonPr === void 0 ? {} : _props$cancelButtonPr,
      _props$okButtonProps = props.okButtonProps,
      okButtonProps = _props$okButtonProps === void 0 ? {} : _props$okButtonProps,
      cancelText = props.cancelText,
      okText = props.okText,
      top = props.top,
      width = props.width,
      height = props.height,
      _props$size = props.size,
      size = _props$size === void 0 ? 'sm' : _props$size,
      icon = props.icon,
      disableAnimation = props.disableAnimation,
      defaultShow = props.defaultShow,
      domRef = props.domRef,
      _props$keyboard = props.keyboard,
      keyboard = _props$keyboard === void 0 ? true : _props$keyboard,
      extra = _objectWithoutPropertiesLoose(props, _excluded);

  var rtl = (0, _reactConfig.useDirection)() === 'rtl';

  var _useUncontrolledShow = (0, _reactHooks.useUncontrolledShow)({
    show: unsafeShow,
    defaultShow: defaultShow
  }),
      show = _useUncontrolledShow[0],
      setShow = _useUncontrolledShow[1];

  var _useState = (0, _react.useState)(false),
      appearedCauseOfMotion = _useState[0],
      setAppearedCauseOfMotion = _useState[1];

  var elementRef = (0, _react.useRef)(null);
  var contentRef = (0, _react.useRef)(null);
  var internalRef = (0, _react.useRef)(null);
  var combinedRef = (0, _reactHooks.useCombineRef)(internalRef, domRef);
  var onOkCallback = (0, _reactHooks.useRefCallback)(onOk);

  var handleCancel = function handleCancel(reason) {
    if (reason === void 0) {
      reason = '';
    }

    if (onCancel) return onCancel === null || onCancel === void 0 ? void 0 : onCancel();
    onClose === null || onClose === void 0 ? void 0 : onClose(reason);
  };

  var onCancelCallback = (0, _reactHooks.useRefCallback)(function () {
    handleCancel();
  });
  var localeCancel = (0, _reactConfig.useLocale)('modal.cancel');
  var localeOk = (0, _reactConfig.useLocale)('modal.ok');
  var okCls = (0, _reactConfig.usePrefixCls)(type + "-ok");
  var cancelCls = (0, _reactConfig.usePrefixCls)(type + "-cancel");
  var footerCls = (0, _reactConfig.usePrefixCls)(type + "-footer");

  var renderFooter = function renderFooter() {
    if (type !== 'normal' && footer === undefined) {
      var showCancelButton = type === 'confirm';
      return _react.default.createElement(_ModalFooter.InternalModalFooter, {
        ref: footerRef,
        align: "end",
        className: footerCls,
        showCancelButton: showCancelButton,
        cancelButtonProps: cancelButtonProps,
        cancelButtonclassName: cancelCls,
        cancelText: cancelText || localeCancel,
        okButtonProps: okButtonProps,
        okButtonclassName: okCls,
        okText: okText || localeOk,
        onCancelCallback: onCancelCallback,
        onOkCallback: onOkCallback
      });
    }

    return footer;
  };

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      dom: internalRef.current,
      show: function show() {
        return setShow(true);
      },
      hide: function hide() {
        return setShow(false);
      }
    };
  }, [setShow]);
  var disableLeaveMotion = !!disableAnimation;
  var disableEnterMotion = disableAnimation === true;
  var shouldApplyEnterMotion = show && !appearedCauseOfMotion && !disableEnterMotion;
  var shouldApplyLeaveMotion = !show && appearedCauseOfMotion && !disableLeaveMotion;
  var keyboardClose = (0, _react.useCallback)(function (event) {
    if (keyboard && event.key === 'Escape') {
      handleCancel('keyboard');
    }
  }, []);

  var _useLockScroll = (0, _reactHooks.useLockScroll)(lockScroll),
      lock = _useLockScroll.lock,
      unlock = _useLockScroll.unlock;

  var disableLeaveMotionRefGetter = (0, _reactHooks.useRefGetter)(disableLeaveMotion);
  (0, _react.useEffect)(function () {
    if (show) {
      lock();
    } else {
      if (disableLeaveMotionRefGetter()) {
        unlock();
        afterClose === null || afterClose === void 0 ? void 0 : afterClose();
      }
    }
  }, [show]);
  var showRef = (0, _react.useRef)(show);
  showRef.current = show;
  (0, _react.useEffect)(function () {
    return function () {
      if (showRef.current) unlock();
    };
  }, []);

  var handleEnterStart = function handleEnterStart() {
    if (shouldApplyEnterMotion) {
      setAppearedCauseOfMotion(true);
    }
  };

  var mountRef = (0, _react.useRef)(show || !lazyInit);

  var handleLeaveEnd = function handleLeaveEnd() {
    if (shouldApplyLeaveMotion) {
      mountRef.current = hideToDestroy ? false : mountRef.current;
      setAppearedCauseOfMotion(false);
      unlock();
      afterClose === null || afterClose === void 0 ? void 0 : afterClose();
    }
  };

  var handleIconClose = (0, _reactHooks.useRefCallback)(function () {
    handleCancel('closeIcon');
  });
  var handleMaskClick = (0, _reactHooks.useRefCallback)(function () {
    if (maskClosable) {
      handleCancel('mask');
    }
  });
  var isAppeared = show && (appearedCauseOfMotion || disableEnterMotion);
  var isDisplayed = show || appearedCauseOfMotion && !disableLeaveMotion;
  var wrapperCls = (0, _reactConfig.usePrefixCls)('modal-wrapper', {
    rtl: rtl
  });
  var maskCls = (0, _reactConfig.usePrefixCls)('modal-mask', {
    show: isAppeared
  });
  var bodyCls = (0, _reactConfig.usePrefixCls)('modal-body', {
    'no-top': top === undefined
  });
  var contentCls = (0, _reactConfig.usePrefixCls)('modal', {
    size: size,
    show: isAppeared,
    rtl: rtl
  });
  var closeIconCls = (0, _reactConfig.usePrefixCls)('modal-close-icon');

  if (disableLeaveMotion && !show && hideToDestroy) {
    mountRef.current = false;
  } else if (!mountRef.current) {
    mountRef.current = !!show;
  }

  if (!mountRef.current) {
    return null;
  }

  return _react.default.createElement(_dialog.RcDialog, _extends({}, extra, {
    toBody: true,
    ref: combinedRef,
    contentRef: contentRef,
    className: (0, _reactUtils.classnames)(bodyCls, bodyClassName),
    style: bodyStyle,
    mask: mask,
    maskClassName: (0, _reactUtils.classnames)(maskCls, maskClassName),
    maskStyle: maskStyle,
    onMaskClick: handleMaskClick,
    wrapperClassName: (0, _reactUtils.classnames)(wrapperCls, wrapperClassName),
    wrapperStyle: _extends({}, wrapperStyle, isDisplayed ? null : {
      display: 'none'
    }),
    animation: {
      show: show,
      type: 'transition',
      validTarget: elementRef,
      validProperty: 'transform',
      disabled: disableEnterMotion && disableLeaveMotion,
      enter: {
        onStart: handleEnterStart
      },
      leave: {
        onEnd: handleLeaveEnd
      }
    },
    onKeyDown: keyboardClose
  }), _react.default.createElement(_Content.Content, {
    inModal: true,
    show: show,
    className: (0, _reactUtils.classnames)(contentCls, className),
    style: _extends({
      top: top,
      width: width,
      height: height
    }, style),
    prefixCls: "modal-content",
    containerRef: elementRef,
    header: header,
    icon: icon,
    divider: divider,
    footer: renderFooter()
  }, !!closeable && _react.default.createElement(_icons.CloseSmall, {
    className: closeIconCls,
    onClick: handleIconClose
  }), _react.default.createElement(_layer.LayerContext.Provider, {
    value: elementRef
  }, children)));
});

exports.Modal = Modal;
Modal.displayName = 'Modal';